import { render, staticRenderFns } from "./justgage.vue?vue&type=template&id=26908ae8"
import script from "./justgage.vue?vue&type=script&lang=js"
export * from "./justgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports